export default __webpack_public_path__ + "static/media/persistent-kraver.0152f9e0.svg";